module.exports = __webpack_public_path__ + "media/images/splash/fillintheblanks-white-94a8486bf8c75dac42a0e8511249fd84.svg";